<template>
    <div class="chat-box-cc">
        <div class="chat-box-cc-header">
            {{ sender.name }}
            <span
                v-on:click="$parent.closeChat(receiver.id)"
                class="chat-box-cc-toggle"
            >
                <i class="fa fa-window-close" aria-hidden="true"></i>
            </span>
        </div>
        <div v-if="showTab" class="chat-box-cc-body">
            <div class="chat-box-cc-overlay"></div>
            <div class="chat-logs-cc" id="chat-logs-cc">
                <div
                    :id="'cm-msg-' + index"
                    class="chat-msg-cc"
                    v-for="(message, index) in messages" :key="index"
                    :class="message.sender_id === sender.id ? 'user' : 'self'"
                >
                  <div v-if=" (receiver.id === message.receiver.id && sender.id === message.sender.id)
                        ||
                        (sender.id === message.receiver.id && receiver.id === message.sender.id)
                    ">
                    <span class="msg-avatar-cc">
                        <img width="45" :src="'@/assets/images/profile.png'" alt=""/>
                    </span>
                    <div class="cm-msg-text">
                      {{ message.message }}
                    </div>
                  </div>

                </div>
            </div>
        </div>
        <div v-if="showTab" class="chat-input-cc">
            <form @submit.prevent="sendMessage()" action="" method="post">
                <input
                    v-if="chat.status === 'open'"
                    type="text"
                    id="chat-input-cc"
                    placeholder="Send a message..."
                    v-model="message"
                />
                <input
                    v-else-if="chat.status === 'block'"
                    disabled="chat.status === 'block'"
                    type="text"
                    id="chat-input-cc"
                    placeholder="Blocked"
                    v-model="message"
                />
                <button
                    :disabled="!message"
                    type="submit"
                    class="chat-submit-cc"
                    id="chat-submit-cc"
                >
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import {GlobalEventBus} from "@/assets/js/eventBus";

const getMessagesRoute = 'v1/message';
const sendMessageRoute = 'v1/message/send';

export default {
    name: "FloatingChatComponent",
    props: ["receiver", "sender"],
    data() {
        return {
            message: "",
            chat: {},
            messages: [],
            showChat: false,
            showTab: true,
        };
    },
    created() {
        this.getMessages();
    },
    watch: {
        messages: function () {
            this.scroll_bottom();
        },
    },
    mounted() {
        let self = this;
        self.listenForEvent();
    },
    methods: {
        async getMessages() {
            let self = this;
            let formData = new FormData();
            formData.append("receiver_id", self.receiver.id);
            formData.append("sender_id", self.sender.id);
            const { data } = await getMessagesRoute.post(formData);
            self.messages = data.data;
            self.chat = data.chat;
        },
        async sendMessage() {
            let formData = new FormData();
            let self = this;
            formData.append("receiver_id", this.sender.id);
            formData.append("message", this.message);
            await sendMessageRoute.post(formData);
            this.messages.push({
                sender: self.receiver,
                sender_id: self.receiver.id,
                receiver: self.sender,
                receiver_id: self.sender.id,
                message: self.message,
            });
            this.message = "";
        },
        scroll_bottom() {
            document.getElementById("chat-logs").scrollTop =
                document.getElementById("chat-logs").scrollHeight;
        },
        listenForEvent() {
            let self = this;
            window.Echo.private("chat").listen("MessageSent", (e) => {
                if (
                    self.sender.id === e.sender.id ||
                    self.receiver.id === e.receiver.id
                ) {
                    self.messages.push({
                        id: e.id,
                        sender: e.sender,
                        sender_id: e.sender.id,
                        receiver: e.receiver,
                        receiver_id: e.receiver.id,
                        message: e.message,
                    });
                }
            });

            GlobalEventBus.on("openChat", function () {
                self.showChat = !self.showChat;
            });
        },
    },
};
</script>

<style scoped>
html,
body {
    background: #efefef;
    height: 100%;
}
#center-text {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}
#chat-circle {
    position: fixed;
    bottom: 50px;
    right: 50px;
    background: #532d5f;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    color: white;
    padding: 28px;
    cursor: pointer;
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.6),
        0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.btn#my-btn {
    background: white;
    border-radius: 45px;
    padding: 13px 40px 12px;
    color: #5865c3;
}
#chat-overlay {
    background: rgba(255, 255, 255, 0.1);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: none;
}

.chat-box-cc {
    z-index: 999;
    background: #efefef;
    bottom: 2px;
    width: 350px;
    max-width: 85vw;
    max-height: 100vh;
    border-radius: 5px;
    box-shadow: 0 5px 35px 9px #3f366d;
    margin-right: 50px;
}
.chat-box-cc-toggle {
    float: right;
    /*margin-right: 15px;*/
    cursor: pointer;
}
.chat-box-cc-header {
    background: #532d5f;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    margin-bottom: 0;
    padding: 5px 10px 5px;
    font-family: "Roboto", sans-serif;
}
.chat-box-cc-body {
    position: relative;
    height: 370px;
    height: auto;
    border: 1px solid #ccc;
    overflow: hidden;
}
.chat-box-cc-body:after {
    content: "";
    background-image: url("data:image/svg+xml;base64,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");
    opacity: 0.1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    position: absolute;
    z-index: -1;
}
#chat-input-cc {
    background: #f4f7f9;
    width: 350px;
    position: relative;
    height: 47px;
    padding: 10px 50px 10px 15px;
    border: none;
    resize: none;
    outline: none;
    border: 1px solid #ccc;
    color: #888;
    border-top: none;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    overflow: hidden;
}
.chat-input-cc > form {
    margin-bottom: 0;
}
#chat-input-cc::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #ccc;
}
#chat-input-cc::-moz-placeholder {
    /* Firefox 19+ */
    color: #ccc;
}
#chat-input-cc:-ms-input-placeholder {
    /* IE 10+ */
    color: #ccc;
}
#chat-input-cc:-moz-placeholder {
    /* Firefox 18- */
    color: #ccc;
}
.chat-submit-cc {
    position: absolute;
    bottom: 3px;
    right: 10px;
    background: transparent;
    box-shadow: none;
    border: none;
    border-radius: 50%;
    color: #532d5f;
    width: 35px;
    height: 35px;
}
.chat-logs-cc {
    padding: 15px;
    height: 370px;
    overflow-y: auto;
}

.chat-logs-cc::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
}

.chat-logs-cc::-webkit-scrollbar {
    width: 5px;
    background-color: #f5f5f5;
}

.chat-logs-cc::-webkit-scrollbar-thumb {
    background-color: #5a5eb9;
}

@media only screen and (max-width: 500px) {
    .chat-logs-cc {
        height: 40vh;
    }
}

.chat-msg-cc.user > .msg-avatar-cc img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    float: left;
    width: 15%;
}
.chat-msg-cc.self > .msg-avatar-cc img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    float: right;
    width: 15%;
}
.cm-msg-text {
    background: white;
    padding: 10px 15px 10px 15px;
    color: #666;
    max-width: 75%;
    float: left;
    margin-left: 10px;
    position: relative;
    margin-bottom: 20px;
    border-radius: 30px;
}
.chat-msg-cc {
    clear: both;
}
.chat-msg-cc.self > .cm-msg-text {
    float: right;
    margin-right: 10px;
    background: #482962;
    color: white;
}
.cm-msg-button > ul > li {
    list-style: none;
    float: left;
    width: 50%;
}
.cm-msg-button {
    clear: both;
    margin-bottom: 70px;
}
</style>
